import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type InquiryRow } from '../../lib/api.js';

export function AdminInquiries() {
  const [inquiries, setInquiries] = useState<InquiryRow[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<'all' | 'open' | 'closed'>('open');

  async function reload() {
    try {
      const res = await api.get<{ inquiries: InquiryRow[] }>(
        `/api/admin/inquiries?status=${status}`,
      );
      setInquiries(res.inquiries);
    } catch (err) {
      setError((err as Error).message);
    }
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <div>
      <header className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">문의</h1>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value as 'all' | 'open' | 'closed')}
          className="px-3 py-1.5 border border-neutral-300 rounded-md text-sm"
        >
          <option value="open">진행 중</option>
          <option value="closed">종료</option>
          <option value="all">전체</option>
        </select>
      </header>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="bg-surface border border-neutral-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-neutral-600 text-xs uppercase tracking-wide">
            <tr>
              <th className="text-left px-4 py-2 font-medium">제목</th>
              <th className="text-left px-4 py-2 font-medium">고객사</th>
              <th className="text-left px-4 py-2 font-medium">작성자</th>
              <th className="text-left px-4 py-2 font-medium">카테고리</th>
              <th className="text-left px-4 py-2 font-medium">상태</th>
              <th className="text-left px-4 py-2 font-medium">최근 메시지</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {inquiries.map((i) => (
              <tr key={i.id} className="hover:bg-neutral-50/50">
                <td className="px-4 py-2">
                  <Link
                    to={`/admin/inquiries/${i.id}`}
                    className="text-brand-600 hover:underline font-medium"
                  >
                    {i.subject}
                  </Link>
                </td>
                <td className="px-4 py-2 text-neutral-700">{i.customerName ?? '—'}</td>
                <td className="px-4 py-2 text-neutral-700">{i.openerName ?? '—'}</td>
                <td className="px-4 py-2 text-neutral-600">
                  {i.category === 'product' ? '제품' : '라이선스'}
                </td>
                <td className="px-4 py-2">
                  {i.status === 'open' ? (
                    <span className="text-green-700 text-xs font-medium">open</span>
                  ) : (
                    <span className="text-neutral-500 text-xs font-medium">closed</span>
                  )}
                </td>
                <td className="px-4 py-2 text-neutral-500 text-xs">
                  {new Date(i.lastMessageAt).toLocaleString('ko-KR')}
                </td>
              </tr>
            ))}
            {inquiries.length === 0 && (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-neutral-500">
                  해당 상태의 문의가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
